import { DeleteOutlined } from "@ant-design/icons";
import { Button, Flex } from "antd";
import { observer } from "mobx-react-lite";
import * as React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { deleteCatalogRecord } from "src/business/records/apiRecords";
import { onError } from "src/common/onError";
import { DeleteConfirm } from "src/components/DeleteConfirm";
import { LoaderBox } from "src/components/LoaderBox";
import { msgQueueStore } from "src/components/MsgQueue";
import { makeUrl } from "src/routes/makeUrl";
import { PageUrl } from "src/routes/PageUrl";

import { CatalogRecordForm } from "../CatalogRecordForm";
import { RecordCardCommonBox } from "../RecordCardCommonBox";
import { WfStatusIcon } from "../RecordsPage/sysWfStatusColumn";
import {
  CatalogCardData,
  catalogCardStore as pageStore,
} from "./catalogCardStore";
import { RecordCardActions } from "./RecordCardActions";

export const RecordCardPage: React.FC = observer(() => {
  const { id = "" } = useParams();
  React.useEffect(() => {
    pageStore.init(id).catch(onError);
  }, [id]);
  return (
    <RecordCardCommonBox
      title={pageStore.breadcrumbs}
      mode="card"
      recordId={id}
    >
      <LoaderBox
        remoteData={pageStore.data}
        drawReady={(data) => <Inner data={data} />}
      />
    </RecordCardCommonBox>
  );
});

const Inner: React.FC<{ data: CatalogCardData }> = observer(({ data }) => {
  const navigate = useNavigate();
  const deleteTask = async () => {
    await deleteCatalogRecord(data.record.id);
    pageStore.cdsFormStore?.setAsUnchanged();
    navigate(makeUrl(PageUrl.records, { id: data.catalog.id }), {
      replace: true,
    });
  };
  const { permissions = {} } = data.record;
  const readOnly = !permissions.canUpdate;
  React.useEffect(() => {
    pageStore.cdsFormStore?.form.root.setDisabled(readOnly);
  }, [readOnly, pageStore.cdsFormStore?.form.root]);
  if (!pageStore.cdsFormStore) return null;
  return (
    <>
      <CatalogRecordForm
        store={pageStore.cdsFormStore}
        title={
          <Flex align="center" gap={16}>
            <WfStatusIcon workflowLock={data.record.workflowLock} />
            {pageStore.title}
          </Flex>
        }
        okText="Сохранить"
        submit={(values) => pageStore.submit(values)}
        onSuccess={() =>
          msgQueueStore.add({
            type: "info",
            message: "Выполнено сохранение данных",
          })
        }
        readOnly={readOnly}
        extra={
          <>
            {!!permissions.canDelete && (
              <Button
                danger
                icon={<DeleteOutlined />}
                onClick={() => pageStore.setDeleting(true)}
              >
                Удалить
              </Button>
            )}
            <RecordCardActions
              actions={data.record.actions}
              catalogId={data.catalog.id}
              catalogCardId={data.record.id}
            />
          </>
        }
      />
      <DeleteConfirm
        content="Карточка будет удалена без возможности восстановления"
        open={pageStore.deleting}
        close={() => pageStore.setDeleting(false)}
        task={deleteTask}
      />
    </>
  );
});
